/**
 * MenuElement elemento que maneja la lista de menu.
 * @author Santiago V. <snippetdeveloper@gmail.com>
 * @copyright (c) 2019 Snippet Developer.
 */

export const menus = [
    {
        'name': 'Home',
        'icon': 'home',
        'link': '/auth/dashboard',
        'open': false
    },
    {
        'name': 'List Users',
        'icon': 'persons',
        'open': false,
        'link': false,
        'sub': [
            {
                'name': 'List',
                'icon': 'reorder',
                'open': false,
                'link': 'company',
            },
            {
                'name': 'Form Add',
                'icon': 'note_add',
                'open': false,
                'link': 'company-add',
            }
        ]
    }
];
